export default function LabelPropagationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.56857 2.81791C9.15113 2.23535 9.95575 1.93302 10.7712 1.99028L13.5307 2.18401C14.9086 2.28074 15.9966 3.36871 16.0933 4.74657L16.287 7.50605C16.3443 8.32155 16.0419 9.12617 15.4594 9.70873L10.8894 14.2787C9.78726 15.3809 8.01234 15.3928 6.925 14.3055L3.97179 11.3523C2.88445 10.265 2.89644 8.49004 3.99856 7.38791L8.56857 2.81791Z"
        stroke="currentColor"
        strokeWidth="0.864266"
        strokeLinejoin="round"
      />
      <path
        d="M3.18164 1V5"
        stroke="currentColor"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.18164 2.99902H5.18164"
        stroke="currentColor"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
